angular.module('app.directives').directive('vpDateTimePicker', () => ({
    restrict: 'E',

    scope: {
        model: '=',
        label: '@?',
        required: '@?',
    },

    controller($scope, $element, $window) {
        $scope.id = Math.round(1000 + Math.random() * 8999);

        // assign this event only ONCE
        if (!$window.vpDateTimePickerEventSetup) {
            $window.vpDateTimePickerEventSetup = true;

            // show tp window after dp one
            jQuery('body').on('pick.uk.datepicker', (event) => {
                const $input = angular.element(event.target);
                const dpId = $input.attr('id') || '';

                // czy nasz komponent?
                if (0 !== dpId.indexOf('vp-datepicker')) {
                    return true;
                }

                const selector = `#${dpId.replace(/vp-datepicker/, 'vp-timepicker')}`;
                const element = angular.element(selector);

                $window.UIkit.dropdown(element).show();
            });
        }

        $scope.$watch('model', (nv, ov) => {
            if (nv && ov && 10 === nv.length && 16 === ov.length) {
                // zmiana daty - przywracamy czas
                $scope.model = nv + ov.substr(10, 6);
            } else if (nv && !ov && 10 === nv.length) {
                // zmiana daty - dodajemy domyślny czas
                $scope.model = `${nv} 08:00`;
            } else if (!nv) {
                // brak daty - wstawiamy aktualną
                $scope.model = moment().format('YYYY-MM-DD 08:00');
            }

            if ($scope.model && 16 === $scope.model.length) {
                $scope.hour = $scope.model.substr(11, 2);
                $scope.minute = $scope.model.substr(14, 2);
            }
        });

        $scope.hourOptions = [];
        $scope.hourOptions = _.map(_.range(0, 24, 1), (hour) => {
            hour = hour < 10 ? `0${hour}` : hour;

            return {
                value: hour,
                label: hour,
            };
        });

        $scope.minuteOptions = [];
        $scope.minuteOptions = _.map(_.range(0, 55, 5), (minute) => {
            minute = minute < 10 ? `0${minute}` : minute;

            return {
                value: minute,
                label: minute,
            };
        });

        $scope.$watch('hour', (v) => {
            if ($scope.model) {
                $scope.model = $scope.model.substr(0, 11) + v + $scope.model.substr(13);
            }
        });
        $scope.hour = '08';

        $scope.$watch('minute', (v) => {
            if ($scope.model) {
                $scope.model = $scope.model.substr(0, 14) + v + $scope.model.substr(16);
            }
        });
        $scope.minute = '00';
    },

    templateUrl: '/directives/date-time-picker/date_time_picker.html',
}));
